"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
var AZERTY_TABLET_LAYOUT = [[{
  key: "1"
}, {
  key: "2"
}, {
  key: "3"
}, {
  key: "4"
}, {
  key: "5"
}, {
  key: "6"
}, {
  key: "7"
}, {
  key: "8"
}, {
  key: "9"
}, {
  key: "0"
}], [{
  key: "a"
}, {
  key: "z"
}, {
  key: "e"
}, {
  key: "r"
}, {
  key: "t"
}, {
  key: "y"
}, {
  key: "u"
}, {
  key: "i"
}, {
  key: "o"
}, {
  key: "p"
}], [{
  key: "q"
}, {
  key: "s"
}, {
  key: "d"
}, {
  key: "f"
}, {
  key: "g"
}, {
  key: "h"
}, {
  key: "j"
}, {
  key: "k"
}, {
  key: "l"
}, {
  key: "m"
}], [{
  key: "←",
  width: 2
}, {
  key: "w"
}, {
  key: "x"
}, {
  key: "c"
}, {
  key: "v"
}, {
  key: "b"
}, {
  key: "n"
}, {
  key: "Clear",
  width: 2
}], [{
  key: "@",
  width: 1.5
}, {
  key: ".",
  width: 1.5
}, {
  key: "-",
  width: 1.5
}, {
  key: "Space",
  width: 8
}, {
  key: "_",
  width: 1.5
}, {
  key: ",",
  width: 1.5
}]];

// 🔹 Touche avec feedback forcé
var KeyButton = /*#__PURE__*/(0, _react.memo)(function KeyButton(_ref) {
  var label = _ref.label,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 1 : _ref$width,
    onPress = _ref.onPress,
    fontFamily = _ref.fontFamily;
  var ref = (0, _react.useRef)(null);
  var handlePointerDown = function handlePointerDown() {
    var el = ref.current;
    if (!el) return;
    el.classList.add("pressed");

    // feedback visible même pour un tap ultra rapide
    setTimeout(function () {
      el.classList.remove("pressed");
    }, 110);
    onPress(label);
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    ref: ref,
    className: "azerty-key",
    onPointerDown: handlePointerDown,
    style: {
      flex: width,
      fontFamily: fontFamily
    }
  }, label === "Space" ? "Espace" : label);
});
function AzertyKeyboardBatibouw(_ref2) {
  var input = _ref2.input,
    setInput = _ref2.setInput,
    project = _ref2.project,
    setVisible = _ref2.setVisible,
    anchorRef = _ref2.anchorRef;
  var keyboardRef = (0, _react.useRef)(null);
  var _ref3 = (0, _react.useState)({
      top: 0,
      left: 0,
      width: 400
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    position = _ref4[0],
    setPosition = _ref4[1];

  // 📍 Position calculée une seule fois
  (0, _react.useLayoutEffect)(function () {
    if (!(anchorRef !== null && anchorRef !== void 0 && anchorRef.current)) return;
    var rect = anchorRef.current.getBoundingClientRect();
    setPosition({
      top: Math.round(rect.bottom * 0.7),
      left: Math.round(rect.left - 60 + rect.width / 2),
      width: Math.round(rect.width)
    });
  }, []);

  // ⌨️ Gestion des touches
  var handleKeyClick = (0, _react.useCallback)(function (key) {
    setInput(function (prev) {
      if (key === "←") return prev.slice(0, -1);
      if (key === "Space") return prev + " ";
      if (key === "Clear") return "";
      return prev + key;
    });
  }, [setInput]);

  // 👆 Click extérieur → fermer
  (0, _react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(e) {
      if (keyboardRef.current && !keyboardRef.current.contains(e.target)) {
        setVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [setVisible]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("style", null, "\n          .azerty-key {\n            height: 55px;\n            min-width: 50px;\n            border-radius: 14px;\n            border: 1px solid #7a7a7a;\n            background: rgba(185, 185, 185, 0.65);\n            font-size: 1.1em;\n            font-weight: bold;\n            cursor: pointer;\n            touch-action: manipulation;\n            transition:\n              transform 0.08s ease,\n              background-color 0.08s ease,\n              box-shadow 0.08s ease;\n            box-shadow: inset 0 1px 0 rgba(255,255,255,0.4);\n          }\n\n          /* \uD83D\uDD25 feedback fort et fiable */\n          .azerty-key.pressed {\n            transform: translateY(3px) scale(0.84);\n            background: rgba(110, 110, 110, 0.95);\n            border-color: #444;\n            box-shadow: inset 0 5px 10px rgba(0,0,0,0.55);\n          }\n        "), /*#__PURE__*/_react.default.createElement("div", {
    ref: keyboardRef,
    style: {
      position: "fixed",
      top: "".concat(position.top, "px"),
      left: "".concat(position.left, "px"),
      transform: "translateX(-58%)",
      zIndex: 1000,
      backgroundColor: "rgba(185,185,185,0.65)",
      padding: "1em",
      borderRadius: "20px",
      boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
      width: "".concat(position.width * 1.9, "px"),
      maxWidth: "850px"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "0.6em"
    }
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return setVisible(false);
    },
    style: {
      backgroundColor: "rgba(255,255,255,0.5)",
      border: "1px solid #868686",
      borderRadius: "9999px",
      padding: "0.3em 0.8em",
      cursor: "pointer"
    }
  }, "X")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "0.3em"
    }
  }, AZERTY_TABLET_LAYOUT.map(function (row, rowIndex) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: rowIndex,
      style: {
        display: "flex",
        gap: "0.1em",
        justifyContent: "center"
      }
    }, row.map(function (_ref5, i) {
      var key = _ref5.key,
        width = _ref5.width;
      return /*#__PURE__*/_react.default.createElement(KeyButton, {
        key: i,
        label: key,
        width: width,
        onPress: handleKeyClick,
        fontFamily: (project === null || project === void 0 ? void 0 : project.default_button_font) || "Arial"
      });
    }));
  }))));
}
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(AzertyKeyboardBatibouw);